import { render, staticRenderFns } from "./wy-panel-header-transcript-info.vue?vue&type=template&id=5f8d04f1&"
import script from "./wy-panel-header-transcript-info.vue?vue&type=script&lang=js&"
export * from "./wy-panel-header-transcript-info.vue?vue&type=script&lang=js&"
import style0 from "./wy-panel-header-transcript-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports